import React, {useEffect} from "react";
import PublicationCard from "./publicationCard/publicationCard";
import "./publicationsList.scss";

const PublicationsList = ({props}) => {
    const { results } = props;

    return(
        <div id="results" className={" pr-g"}>
            {results.map(
                (publication, index) =>
                    <PublicationCard props={publication} />
            )}
        </div>
    )
}

export default PublicationsList;
